import { render, staticRenderFns } from "./specPosition.vue?vue&type=template&id=8c4ed8ba"
import script from "./specPosition.vue?vue&type=script&lang=js"
export * from "./specPosition.vue?vue&type=script&lang=js"
import style0 from "./specPosition.vue?vue&type=style&index=0&id=8c4ed8ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports